import { useEffect, useState } from 'react';

import _ from 'lodash';
import * as qs from 'query-string';
import classNames from 'classnames';

import pushRouterHelper from 'hooks/useRouterHelper';
import { ReactComponent as ExpandArrow } from 'assets/icons/arrow-down.svg';

import Section from './Section';

import './Chapter.scoped.scss';

interface Props {
  chapter: any;
  title: string;
  percentage: number;
}

const Chapter: React.FC<Props> = ({ chapter, title, percentage }) => {
  const { routePush } = pushRouterHelper();

  const { lesson } = qs.parse(window.location.search);
  const [expanded, setExpanded] = useState(false);
  const [isEnter, setIsEnter] = useState(false);
  useEffect(() => {
    if (_.find(chapter, ['id', lesson])) {
      setExpanded(!expanded);
    }
  }, []);

  const less = percentage < 99;

  return (
    <div>
      <button
        className={classNames('chapter', { less }, { equal: !less }, { expanded })}
        onClick={() => {
          setExpanded(!expanded);
        }}
        style={{
          backgroundColor: isEnter && less ? '#FFF6EF' : isEnter && !less ? '#E0FCEE' : '#f2f7fc',
        }}
        onMouseEnter={() => {
          setIsEnter(true);
        }}
        onMouseLeave={() => {
          setIsEnter(false);
        }}
      >
        <div className="titles-container">
          {/* {isEnter && ( */}
          {/*  <div */}
          {/*    className="percentage-section" */}
          {/*    style={{ */}
          {/*      backgroundColor: */}
          {/*        isEnter && less ? '#FD8A28' : isEnter && !less ? '#5CD79E' : '#f2f7fc', */}
          {/*    }} */}
          {/*  > */}
          {/*    <h3 className="title">{percentage}%</h3> */}
          {/*  </div> */}
          {/* )} */}
          <h3 className={classNames('title', { less }, { equal: !less })}>{title}</h3>
        </div>
        <div className="icon-container">
          <ExpandArrow className={`arrow ${expanded && 'expanded'}`} />
        </div>
      </button>
      {expanded && (
        <div className="expanded-chapter">
          {/* for dynamic data use chapter instead of dummyChapter */}
          {chapter &&
            chapter.map(({ id, title, assignment_submits: submits, body }) => {
              return (
                <Section
                  key={id}
                  id={id}
                  title={title}
                  isCompleted={submits.length && submits[0].is_submited}
                  body={body}
                  selectAndUpdateChapter={(content, id) => {
                    routePush({
                      search: {
                        lesson: id,
                        type: 'lesson',
                      },
                    });
                  }}
                  current={lesson as string}
                />
              );
            })}
        </div>
      )}
      {!expanded && (
        <div className="element-section-container">
          <div
            className="element-section"
            style={{ width: `${percentage}%`, backgroundColor: less ? '#FD8A28' : '#5CD79E' }}
          />
        </div>
      )}
    </div>
  );
};

export default Chapter;
